import { createContext } from "react";
import type { AgentContextValue } from "@/context/agent/types.ts";


export const AgentContext = createContext<AgentContextValue | null>(null);

